import { IgSelect } from "@intelligems/ig-theme/IgSelect";
import MenuItem from "@mui/material/MenuItem";

import { InputProps } from "./types";

export interface SelectOption {
  value: string;
  label: string;
}

interface SelectInputProps extends InputProps {
  options: SelectOption[];
}

export const SelectInput = ({
  label,
  value,
  onChange,
  options,
}: SelectInputProps) => (
  <IgSelect
    label={label}
    fullWidth
    size="small"
    value={value}
    onChange={(e) => onChange(e.target.value)}
  >
    {options.map((opt) => (
      <MenuItem key={opt.value} value={opt.value}>
        {opt.label}
      </MenuItem>
    ))}
  </IgSelect>
);
